var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 31 25",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1641 16.4767L11.6513 23.4566C12.385 23.4566 12.7028 23.1516 13.0838 22.7854L16.5236 19.6042L23.6512 24.6554C24.9584 25.3604 25.8794 24.9891 26.232 23.4916L30.9106 2.27675L30.9118 2.2755C31.3265 0.405505 30.213 -0.325741 28.9394 0.133006L1.43918 10.3217C-0.437656 11.0267 -0.409239 12.0392 1.12013 12.4979L8.15084 14.6142L24.4818 4.72548C25.2503 4.23299 25.9491 4.50548 25.3743 4.99798L12.1641 16.4767Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.cef1a5eb248f884a9b374104bd4e5760.svg";
export { ForwardRef as ReactComponent };